import service from '@/utils/server';

const modName='/md/deviceAttribute/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const exportData = data => {
  return service({
    url: modName + 'export',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/md/deviceAttribute/api/index.js